/**
 * React Query hook for the Open Challenges board (GET /challenges/open).
 * Mirrors useChallengeDetailQuery's auth-gating + apiClient usage. specs/open-challenges AC-6.
 */

import { useQuery } from '@tanstack/react-query';
import { useSupabaseAuth } from '../../shared/contexts/SupabaseAuthContext';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { fetchOpenBoard } from '../helpers/openBoardApi';
import { USER_CONFIG } from '../../../constants';

export function useOpenBoardQuery() {
  const apiClient = useApiClient();
  const { userId, isLoaded, isSignedIn, isAnonymous } = useSupabaseAuth();
  const currentUserId = userId ?? USER_CONFIG.defaultUserId;
  // Guests may only play the Monkey (Q-3) and the server refuses their take-on, so don't fetch a
  // board they cannot act on. The Arena hides the toggle too; this is the data-layer half.
  const enabled = isSignedIn === true && isLoaded === true && isAnonymous !== true;

  return useQuery({
    // The feed is per-viewer (affordability + "not mine" are applied server-side), so the user id
    // is part of the key. There are no filter params — browsing happens on the returned page.
    queryKey: ['challenges', 'open-board', currentUserId],
    queryFn: () => fetchOpenBoard(apiClient),
    enabled,
    staleTime: 30 * 1000, // board changes as challenges are taken/expire — keep it fresh
    gcTime: 5 * 60 * 1000,
  });
}
